export const productsPerPageDefault = 36;

export const articlesPerPageDefault = 10;

export const paginationPageParamName = 'page';

export const paginationSmallScreenPagesCount = 3;

export const productRecommendedProductsPerPageDefault = 9;

export const csmProductsPerPageDefault = 96;

export const accountFavouriteProductsPerPageDefault = 36;

export const accountFavouriteProductsPageParamName = 'favPage';
